import { AccountPasswordModel, IAccountPassword } from "@core/models";

export class AccountPasswordDTO extends AccountPasswordModel {
  prepareUpdateData() {
    return {
      current_password: this[IAccountPassword.currentPassword],
      new_password: this[IAccountPassword.newPassword],
      new_password_confirm: this[IAccountPassword.newPasswordConfirm],
    };
  }
}
